
import {
  computed, defineComponent, onBeforeMount, reactive, watch,
} from 'vue';
import Icone from '@/core/components/Icone.vue';
import MensagemSemDados from '@/core/components/Tela/MensagemSemDados.vue';
import { useTelaBase } from '@/core/composables/TelaBase';
import { useGradeBase } from '@/core/composables/GradeBase';
import { IDTOProdutoDefinicao } from '@/models/DTO/Cadastros/Produtos/IDTOProdutoDefinicao';
import UtilitarioGeral from '@/core/utilitarios/UtilitarioGeral';
import { IParametrosConsulta } from '@/core/models/Consulta/IParametrosConsulta';
import UtilitarioMascara from '@/core/utilitarios/UtilitarioMascara';
import ServicoProduto from '@/servicos/Cadastros/Produtos/ServicoProduto';
import BuscaGeral from '@/core/components/BuscaAvancada/BuscaGeral.vue';
import { IOrdenacao } from '@/core/models/Consulta/IOrdenacao';
import { ECustomRenderRow, IColumn } from '@/core/models/AntDesign/IColumn';
import { ETipoRastreabilidade } from '@/models/Enumeradores/Estoques/Rastreabilidade/ETipoRastreabilidade';
import { IParametroConsultaRastreabilidade } from '@/models/ParametrosRequisicao/Estoques/IParametroConsultaRastreabilidade';
import ServicoRastreabilidade from '@/servicos/Estoques/ServicoRastreabilidade';
import Card from '@/core/components/Tela/Card.vue';
import UtilitarioData from '@/core/utilitarios/UtilitarioData';
import { IDTOSelecaoProduto } from '@/models/DTO/Estoques/IDTOSelecaoProduto';
import { ETipoSelecaoProduto } from '@/models/Enumeradores/Estoques/ETipoSelecaoProduto';
import SelecionarEstoque from '@/components/Cadastros/Estoques/SelecionarEstoque.vue';
import CampoNumerico from '@/core/components/Tela/CampoNumerico.vue';
import { IControleProducao } from '@/models/Entidades/Cadastros/PCP/IControleProducao';
import ServicoControleProducao from '@/servicos/Cadastros/PCP/ServicoControleProducao';
import { ETipoControleProducao } from '@/models/Enumeradores/Cadastros/PCP/ETipoControleProcucao';
import { ETipoLancamentoRastreabilidade } from '@/models/Enumeradores/Estoques/Rastreabilidade/ETipoLancamentoRastreabilidade';
import { IParametrosConsultaProdutoDefinicao } from '@/models/ParametrosRequisicao/Cadastros/Produtos/IParametrosConsultaProdutoDefinicao';

export default defineComponent({
  name: 'ConsultaProdutosModal',
  props: {
    empresa: {
      type: Number,
      required: true,
    },
    tipoSelecao: {
      type: Number,
      default: 2,
    },
    controles: {
      type: Array as () => IControleProducao[],
      default: [] as IControleProducao[],
    },
    preSelecao: {
      type: Array as () => IDTOSelecaoProduto[],
      default: [] as IDTOProdutoDefinicao[],
    },
    codigosSelecionados: {
      type: Array as () => number[],
      default: () => [],
    },
    produtos: {
      type: Array as () => IDTOProdutoDefinicao[],
      default: () => [],
    },
  },
  components: {
    Icone,
    MensagemSemDados,
    BuscaGeral,
    Card,
    SelecionarEstoque,
    CampoNumerico,
  },
  emits: ['update:produtos', 'update:codigosSelecionados', 'update:empresa', 'update:controles'],
  setup(props, { emit }) {
    const { telaBase, apresentarMensagemAlerta } = useTelaBase();
    const { gradeBase, preenchePropriedadesNosFiltrosEOrdenacao, defineValoresIniciaisGrade } = useGradeBase();
    const servicoProduto = new ServicoProduto();
    const servicoRastreabilidade = new ServicoRastreabilidade();
    const servicoControleProducao = new ServicoControleProducao();
    servicoProduto.requisicaoSistema();
    servicoControleProducao.requisicaoSistema();
    servicoRastreabilidade.requisicaoSistema();

    const state = reactive({
      ordenacaoCampos: [] as IOrdenacao[],
      colunas: [] as IColumn[],
      colunasEstoques: [] as IColumn[],
      editarQtd: false,
      indexProdutoSelecionado: -1,
      codigoSelecionado: 0,
      estoqueSelecionado: 0,
      qtdSelecionada: 0,
      rastreabilidadeSelecionada: '',
      buscaRapida: '',
      qtdTotalSelecionada: 0,
      qtdRestante: 0,
      qtdProduto: 0,
      windowHeight: (window.innerHeight - 300),
      windowWidth: (window.innerWidth - 100),
      carregandoEstoque: false,
      apenasComSaldo: true,
    });

    const computedProdutos = computed({
      get: () => props.produtos,
      set: (val: IDTOProdutoDefinicao[]) => {
        emit('update:produtos', val);
      },
    });

    const computedCodigosSelecionados = computed({
      get: () => props.codigosSelecionados,
      set: (val: number[]) => {
        emit('update:codigosSelecionados', val);
      },
    });

    const computedEmpresa = computed({
      get: () => props.empresa,
      set: (val: number) => {
        emit('update:empresa', val);
      },
    });

    const computedControles = computed({
      get: () => props.controles,
      set: (val: IControleProducao[]) => {
        emit('update:controles', val);
      },
    });

    function verificarUsoUnidadeSecundaria() {
      let usouUnidadeSecundaria = false;
      if (UtilitarioGeral.validaLista(props.preSelecao)) {
        props.preSelecao.forEach((p) => {
          if (p.fatorConversao !== 1) {
            usouUnidadeSecundaria = true;
          }
        });
      }

      return usouUnidadeSecundaria;
    }

    function preencherColunas() {
      state.colunas = [];
      state.colunas.push({
        title: 'Código Definição', dataIndex: 'codigoDefinicao', key: 'CodigoDefinicao', position: 0, visible: false, ordering: true,
      });
      state.colunas.push({
        title: 'Código Interno', dataIndex: 'codigoInterno', key: 'CodigoInternoProduto', width: 80, ellipsis: true, position: 1, visible: true, ordering: true, align: 'right',
      });
      state.colunas.push({
        title: 'Produto', dataIndex: 'produto', key: 'DescricaoProduto', width: 300, ellipsis: true, position: 2, visible: true, ordering: true, align: 'left',
      });
      state.colunas.push({
        title: 'Unidade', dataIndex: 'unidade', key: 'UnidadeProduto', width: 70, ellipsis: true, position: 3, visible: true, ordering: true, align: 'center',
      });
      if (verificarUsoUnidadeSecundaria()) {
        state.colunas.push({
          title: 'UN Mov', dataIndex: 'unidadeMovimento', key: 'UnidadeMovimento', width: 70, ellipsis: true, position: 3, visible: true, ordering: true, align: 'center',
        });
      }
      state.colunas.push({
        title: 'Tipo de Produto', dataIndex: 'tipoDescricao', key: 'TipoDescricao', width: 100, ellipsis: true, position: 4, visible: true, ordering: true, align: 'left',
      });
      state.colunas.push({
        title: 'Marca', dataIndex: 'marca', key: 'MarcaProduto', width: 100, ellipsis: true, position: 5, visible: true, ordering: true, align: 'left',
      });
      state.colunas.push({
        title: 'Categorias', dataIndex: 'categorias', key: 'Categorias', width: 200, ellipsis: true, position: 6, visible: true, ordering: true, align: 'left',
      });
      state.colunas.push({
        title: 'Qtd Disponível', dataIndex: 'qtdDisponivel', key: 'QtdDisponivel', width: 100, ellipsis: true, position: 6, visible: true, ordering: true, align: 'right', customRenderRow: ECustomRenderRow.MascararFracionado,
      });
      if (props.preSelecao.length > 0 && props.preSelecao[0].quantidade > 0) {
        if (verificarUsoUnidadeSecundaria()) {
          state.colunas.push({
            title: 'Qtd do Mov', dataIndex: 'quantidadeMovimento', key: 'QuantidadeMovimento', width: 100, ellipsis: true, position: 7, visible: true, ordering: true, align: 'right', customRenderRow: ECustomRenderRow.MascararFracionado,
          });
        }
        state.colunas.push({
          title: 'Qtd do Produto', dataIndex: 'quantidade', key: 'Quantidade', width: 100, ellipsis: true, position: 7, visible: true, ordering: true, align: 'right', customRenderRow: ECustomRenderRow.MascararFracionado,
        });
      }
    }

    function preencherColunasEstoques() {
      state.colunasEstoques = [];
      state.colunasEstoques.push({
        title: 'Codigo', dataIndex: 'codigo', key: 'codigo', position: 0, visible: false,
      });
      state.colunasEstoques.push({
        title: 'Código Estoque', dataIndex: 'codigoItemEstoque', key: 'codigoItemEstoque', position: 1, visible: false,
      });
      state.colunasEstoques.push({
        title: 'Estoque', dataIndex: 'descricaoEstoque', key: 'descricaoEstoque', position: 3, visible: true, ordering: true, align: 'left', width: 250,
      });
      if (props.preSelecao.length > 0) {
        state.colunasEstoques.push({
          title: 'Identificador', dataIndex: 'identificador', key: 'Identificador', position: 4, visible: true, ordering: true, align: 'center', width: 140, customRenderRow: ECustomRenderRow.LinkAcao,
        });
      } else {
        state.colunasEstoques.push({
          title: 'Identificador', dataIndex: 'identificador', key: 'Identificador', position: 4, visible: true, ordering: true, align: 'left', width: 140,
        });
      }
      if (computedProdutos.value[state.indexProdutoSelecionado].tipoRastreabilidade === ETipoRastreabilidade.Outros) {
        state.colunasEstoques.push({
          title: 'Descrição', dataIndex: 'descricao', key: 'Descricao', position: 4, visible: true, ordering: true, align: 'left',
        });
      } else if (computedProdutos.value[state.indexProdutoSelecionado].tipoRastreabilidade === ETipoRastreabilidade.Lote) {
        state.colunasEstoques.push({
          title: 'Nº do Lote', dataIndex: 'numeroLote', key: 'NumeroLote', position: 5, visible: true, ordering: true, align: 'center', width: 100,
        });
        state.colunasEstoques.push({
          title: 'Fabricação', dataIndex: 'dataFabricacao', key: 'DataFabricacao', position: 6, visible: true, ordering: true, align: 'center', width: 100, customRenderRow: ECustomRenderRow.MascararData,
        });
        state.colunasEstoques.push({
          title: 'Validade', dataIndex: 'dataValidade', key: 'DataValidade', position: 7, visible: true, ordering: true, align: 'center', width: 100, customRenderRow: ECustomRenderRow.MascararData,
        });
        if (computedControles.value.some((c) => c.tipoControle === ETipoControleProducao.Densidade)) {
          state.colunasEstoques.push({
            title: 'Densidade', dataIndex: 'densidade', key: 'Densidade', position: 8, visible: true, ordering: true, align: 'center', width: 100,
          });
        }
        if (computedControles.value.some((c) => c.tipoControle === ETipoControleProducao.PH)) {
          state.colunasEstoques.push({
            title: 'PH', dataIndex: 'ph', key: 'Ph', position: 8, visible: true, ordering: true, align: 'center', width: 100,
          });
        }
      } else if (computedProdutos.value[state.indexProdutoSelecionado].tipoRastreabilidade === ETipoRastreabilidade.Armamento) {
        state.colunasEstoques.push({
          title: 'Nº Arma', dataIndex: 'numeroSerieArma', key: 'NumeroSerieArma', position: 5, visible: true, ordering: true, align: 'center', width: 100,
        });
        state.colunasEstoques.push({
          title: 'Nº Cano', dataIndex: 'numeroSerieCano', key: 'NumeroSerieCano', position: 6, visible: true, ordering: true, align: 'center', width: 100,
        });
      }
      state.colunasEstoques.push({
        title: 'Qtd Disponível', dataIndex: 'quantidade', key: 'quantidade', position: 6, visible: true, ordering: true, align: 'right', width: 140, customRenderRow: ECustomRenderRow.MascararFracionado,
      });
      if (props.preSelecao.length > 0) {
        state.colunasEstoques.push({
          title: 'Qtd Selecionada', dataIndex: 'qtdSelecionada', key: 'qtdSelecionada', position: 7, visible: true, ordering: true, align: 'right', width: 140, customRenderRow: ECustomRenderRow.MascararFracionado,
        });
        state.colunasEstoques.push({
          title: 'Ações', key: 'acoes', position: 1, visible: true, width: 70, align: 'center', ellipsis: true, customRenderRow: ECustomRenderRow.IconeAcoes,
        });
      }
    }

    async function obterControles() {
      if (UtilitarioGeral.validaLista(props.controles)) {
        computedControles.value = await servicoControleProducao.obterAtivos(props.empresa);
      }
    }

    async function limparTela() {
      state.ordenacaoCampos = [] as IOrdenacao[];
      state.colunas = [] as IColumn[];
      state.colunasEstoques = [] as IColumn[];
      computedProdutos.value = [] as IDTOProdutoDefinicao[];
      state.editarQtd = false;
      state.indexProdutoSelecionado = -1;
      state.estoqueSelecionado = 0;
      state.qtdSelecionada = 0;
      state.rastreabilidadeSelecionada = '';
      state.buscaRapida = '';
      state.qtdTotalSelecionada = 0;
      state.qtdRestante = 0;
      state.qtdProduto = 0;
      computedCodigosSelecionados.value = [];
      state.codigoSelecionado = -1;
      await obterControles();
      preencherColunas();
    }

    function obterClasseLinha(record: any) {
      return record.codigoDefinicao === state.codigoSelecionado ? 'ss-linha-selecionada' : '';
    }

    async function buscarProdutos() {
      state.editarQtd = false;
      state.indexProdutoSelecionado = -1;
      state.estoqueSelecionado = 0;
      state.qtdSelecionada = 0;
      state.rastreabilidadeSelecionada = '';
      state.qtdTotalSelecionada = 0;
      state.qtdRestante = 0;
      state.qtdProduto = 0;
      computedProdutos.value = [];
      gradeBase.filtrosAplicados = [];
      gradeBase.buscaAvancada.filtrosAdicionados.forEach((item) => {
        gradeBase.filtrosAplicados.push(item.filtro);
      });

      const parametrosConsulta = {} as IParametrosConsulta;
      const parametrosConsultaDefinicao = {} as IParametrosConsultaProdutoDefinicao;
      parametrosConsultaDefinicao.apenasAtivos = true;
      parametrosConsultaDefinicao.mostraDisponibilidade = true;

      parametrosConsulta.valorBuscaRapida = state.buscaRapida;
      parametrosConsulta.empresas = [props.empresa];
      parametrosConsulta.numeroPagina = gradeBase.paginacao.current;
      if (props.preSelecao.length > 0) {
        parametrosConsulta.qtdeRegistrosPagina = 99999999999;
        parametrosConsulta.qtdeRegistrosTotal = 99999999999;
        parametrosConsultaDefinicao.apenasComSaldo = false;
      } else {
        parametrosConsulta.qtdeRegistrosPagina = gradeBase.paginacao.pageSize;
        parametrosConsulta.qtdeRegistrosTotal = gradeBase.paginacao.total;
        parametrosConsultaDefinicao.apenasComSaldo = state.apenasComSaldo;
      }
      parametrosConsulta.ordenacao = Array<string>();
      parametrosConsulta.codigosSelecionados = [] as number[];
      props.preSelecao.forEach((p) => {
        if (parametrosConsulta.codigosSelecionados !== undefined) {
          parametrosConsulta.codigosSelecionados.push(p.codigoProdutoDefinicao);
        }
      });

      gradeBase.ordenacaoSelecionada.forEach((item) => {
        parametrosConsulta.ordenacao.push(`${item.identificador}|${item.ordem}`);
      });

      gradeBase.buscandoDados = true;
      const listaPaginada = await servicoProduto.buscaAvancadaDefinicoes(parametrosConsulta, gradeBase.filtrosAplicados, parametrosConsultaDefinicao);
      if (listaPaginada !== undefined && listaPaginada !== null) {
        if (UtilitarioGeral.validaLista(listaPaginada.dados)) {
          if (UtilitarioGeral.validaLista(props.preSelecao)) {
            let lista = [] as IDTOProdutoDefinicao[];
            lista = listaPaginada.dados;
            const listaOrdenada = [] as IDTOProdutoDefinicao[];
            props.preSelecao.forEach((p) => {
              const index = lista.findIndex((i) => i.codigoDefinicao === p.codigoProdutoDefinicao);
              listaOrdenada.push(lista[index]);
            });

            computedProdutos.value = listaOrdenada;
          } else {
            computedProdutos.value = listaPaginada.dados;
          }
          gradeBase.paginacaoApi = listaPaginada.metaData;
        }
      }
      gradeBase.buscandoDados = false;
    }

    function obterTotalSelecionadoProduto(index: number) {
      let total = 0;
      if (UtilitarioGeral.validaLista(computedProdutos.value[index].estoquesRastreabilidades)) {
        computedProdutos.value[index].estoquesRastreabilidades.forEach((e) => {
          total += e.qtdSelecionada;
        });
      }
      state.qtdTotalSelecionada = total;
      if (props.tipoSelecao === ETipoSelecaoProduto.SelecaoUnica) {
        state.qtdRestante = total;
      } else {
        state.qtdRestante = computedProdutos.value[index].quantidade - total;
      }
    }

    function preencherQtdPreSelecionada(index: number) {
      if (computedProdutos.value[index].quantidade > 0 && ((computedProdutos.value[index].tipoRastreabilidade === ETipoRastreabilidade.Nenhum) || (computedProdutos.value[index].tipoLancamentoRastreabilidade !== ETipoLancamentoRastreabilidade.Manual))) {
        let qtdRestante = computedProdutos.value[index].quantidade;
        if (!UtilitarioGeral.validaLista(computedProdutos.value[index].estoquesRastreabilidades)) {
          return;
        }

        computedProdutos.value[index].estoquesRastreabilidades.forEach((e, indexE) => {
          if (qtdRestante > 0) {
            if (e.quantidade >= qtdRestante) {
              computedProdutos.value[index].estoquesRastreabilidades[indexE].qtdSelecionada = qtdRestante;
              qtdRestante = 0;
            } else {
              computedProdutos.value[index].estoquesRastreabilidades[indexE].qtdSelecionada = e.quantidade;
              qtdRestante -= e.quantidade;
            }
          } else {
            computedProdutos.value[index].estoquesRastreabilidades[indexE].qtdSelecionada = 0;
          }
        });
      } else {
        computedProdutos.value[index].estoquesRastreabilidades.forEach((e, indexE) => {
          computedProdutos.value[index].estoquesRastreabilidades[indexE].qtdSelecionada = 0;
        });
      }
    }

    async function buscarEstoques(index: number) {
      state.indexProdutoSelecionado = index;
      if (index === -1) return;
      if (!UtilitarioGeral.objetoValido(computedProdutos.value[index]) || (UtilitarioGeral.objetoValido(computedProdutos.value[index]) && UtilitarioGeral.validaLista(computedProdutos.value[index].estoquesRastreabilidades))) {
        state.qtdProduto = computedProdutos.value[index].quantidade;
        preencherColunasEstoques();
        obterTotalSelecionadoProduto(index);
        return;
      }
      state.carregandoEstoque = true;
      const produto = await servicoProduto.obterDadosDetalhesDefinicao(computedProdutos.value[index].codigoDefinicao);
      produto.quantidade = computedProdutos.value[index].quantidade;
      produto.qtdDisponivel = computedProdutos.value[index].qtdDisponivel;
      produto.codigoItem = computedProdutos.value[index].codigoItem;
      produto.codigoItemNotaFiscal = computedProdutos.value[index].codigoItemNotaFiscal;
      produto.quantidadeMovimento = computedProdutos.value[index].quantidadeMovimento;
      produto.unidadeMovimento = computedProdutos.value[index].unidadeMovimento;
      computedProdutos.value[index] = produto;
      state.qtdProduto = produto.quantidade;
      const parametros = {} as IParametroConsultaRastreabilidade;
      parametros.codigoItemEstoque = 0;
      parametros.codigoProdutoDefinicao = computedProdutos.value[index].codigoDefinicao;
      parametros.tipoLancamento = computedProdutos.value[index].tipoLancamentoRastreabilidade;
      parametros.tipoRastreabilidade = computedProdutos.value[index].tipoRastreabilidade;
      parametros.mostrarNegativados = !state.apenasComSaldo;
      parametros.empresas = [props.empresa];
      parametros.recurso = 'PAINEL VENDAS';
      computedProdutos.value[index].estoquesRastreabilidades = await servicoRastreabilidade.obterRastreabilidadesProduto(parametros);
      if (UtilitarioGeral.validaLista(computedProdutos.value[index].estoquesRastreabilidades)) {
        computedProdutos.value[index].estoquesRastreabilidades.forEach((e, indexE) => {
          computedProdutos.value[index].estoquesRastreabilidades[indexE].codigoItem = computedProdutos.value[index].codigoItem;
          computedProdutos.value[index].estoquesRastreabilidades[indexE].codigoItemNotaFiscal = computedProdutos.value[index].codigoItemNotaFiscal;
        });
        computedProdutos.value[index].estoquesRastreabilidades.forEach((rast) => {
          const codigoVinculo = computedProdutos.value[index].tipoRastreabilidade === ETipoRastreabilidade.Nenhum ? rast.codigoItemEstoque : rast.codigo;
          const selecionados = props.preSelecao.find((p) => p.codigoProdutoDefinicao === computedProdutos.value[index].codigoDefinicao);

          const selecionado = UtilitarioGeral.validaLista(selecionados?.estoqueRastPrevio) ? selecionados?.estoqueRastPrevio.find((i) => {
            if (computedProdutos.value[index].tipoRastreabilidade === ETipoRastreabilidade.Nenhum) {
              return i.codigoItemEstoque === codigoVinculo;
            }
            return i.codigo === rast.codigo;
          }) : null;
          if (selecionado) {
            // eslint-disable-next-line no-param-reassign
            rast.qtdSelecionada = selecionado.qtdSelecionada;
            // eslint-disable-next-line no-param-reassign
            rast.quantidade += selecionado.qtdSelecionada;
            // eslint-disable-next-line no-param-reassign
            rast.codigoMovimento = selecionado.codigoMovimento;
          }
        });
      }
      preencherColunasEstoques();
      obterTotalSelecionadoProduto(index);
      state.carregandoEstoque = false;
    }

    function selecaoAlterada(selectedRowKeys: any) {
      computedCodigosSelecionados.value = selectedRowKeys;
    }

    function rowHandlers(record: any) {
      return {
        onClick: () => {
          state.codigoSelecionado = record.codigoDefinicao;
          const index = computedProdutos.value.findIndex((prod) => prod.codigoDefinicao === record.codigoDefinicao);
          buscarEstoques(index);
        },
      };
    }

    function preencherIdentificador(index: number) {
      state.editarQtd = false;
      state.rastreabilidadeSelecionada = computedProdutos.value[state.indexProdutoSelecionado].estoquesRastreabilidades[index].identificador;
    }

    function editarQuantidade(index: number) {
      state.editarQtd = true;
      if (props.tipoSelecao === ETipoSelecaoProduto.SelecaoUnica && computedProdutos.value[state.indexProdutoSelecionado]
        .estoquesRastreabilidades.filter((rast, ind) => rast.qtdSelecionada > 0 && ind !== index).length > 0) {
        apresentarMensagemAlerta('Na Criação da ordem de produção só pode ser lançado um lote!');
        return;
      }
      if (computedProdutos.value[state.indexProdutoSelecionado].tipoRastreabilidade === ETipoRastreabilidade.Nenhum) {
        state.estoqueSelecionado = computedProdutos.value[state.indexProdutoSelecionado].estoquesRastreabilidades[index].codigoEstoque;
        state.qtdSelecionada = computedProdutos.value[state.indexProdutoSelecionado].estoquesRastreabilidades[index].qtdSelecionada;
      } else {
        state.rastreabilidadeSelecionada = computedProdutos.value[state.indexProdutoSelecionado].estoquesRastreabilidades[index].identificador;
        state.qtdSelecionada = computedProdutos.value[state.indexProdutoSelecionado].estoquesRastreabilidades[index].qtdSelecionada;
      }
    }

    function validarQuantidade(index: number) {
      if (state.qtdSelecionada > computedProdutos.value[state.indexProdutoSelecionado].estoquesRastreabilidades[index].quantidade) {
        apresentarMensagemAlerta('A quantidade selecionada não pode ser maior que a quantidade disponível!');
        return false;
      }

      let qtdLancada = 0;
      if (state.editarQtd) {
        qtdLancada = state.qtdSelecionada;
        computedProdutos.value[state.indexProdutoSelecionado].estoquesRastreabilidades.forEach((e) => {
          if (computedProdutos.value[state.indexProdutoSelecionado].tipoRastreabilidade === ETipoRastreabilidade.Nenhum) {
            if (e.codigoEstoque !== state.estoqueSelecionado) qtdLancada += e.qtdSelecionada;
          } else if (e.identificador !== state.rastreabilidadeSelecionada) {
            qtdLancada += e.qtdSelecionada;
          }
        });
      } else {
        qtdLancada = state.qtdSelecionada;
        computedProdutos.value[state.indexProdutoSelecionado].estoquesRastreabilidades.forEach((e) => {
          qtdLancada += e.qtdSelecionada;
        });
      }
      if (qtdLancada > computedProdutos.value[state.indexProdutoSelecionado].quantidade && computedProdutos.value[state.indexProdutoSelecionado].quantidade > 0) {
        apresentarMensagemAlerta('O total da quantidade lançada não pode ser maior que a quantidade necessária do produto!');
        return false;
      }
      return true;
    }

    function adicionarQuantidade() {
      if (computedProdutos.value[state.indexProdutoSelecionado].tipoRastreabilidade === ETipoRastreabilidade.Nenhum) {
        const index = computedProdutos.value[state.indexProdutoSelecionado].estoquesRastreabilidades.findIndex((e) => e.codigoEstoque === state.estoqueSelecionado);
        if (state.estoqueSelecionado === 0) {
          apresentarMensagemAlerta('O estoque deve ser informado');
          return;
        }

        if (!validarQuantidade(index)) return;

        computedProdutos.value[state.indexProdutoSelecionado].estoquesRastreabilidades[index].qtdSelecionada = state.qtdSelecionada;
        state.estoqueSelecionado = 0;
        state.qtdSelecionada = 0;
      } else {
        const index = computedProdutos.value[state.indexProdutoSelecionado].estoquesRastreabilidades.findIndex((e) => e.identificador === state.rastreabilidadeSelecionada);
        if (state.rastreabilidadeSelecionada === '') {
          apresentarMensagemAlerta('A rastreabilidade deve ser informada');
          return;
        }
        if (!validarQuantidade(index)) return;
        if (state.editarQtd) {
          computedProdutos.value[state.indexProdutoSelecionado].estoquesRastreabilidades[index].qtdSelecionada = state.qtdSelecionada;
        } else {
          computedProdutos.value[state.indexProdutoSelecionado].estoquesRastreabilidades[index].qtdSelecionada += state.qtdSelecionada;
        }
        state.rastreabilidadeSelecionada = '';
        state.qtdSelecionada = 0;
      }
      state.editarQtd = false;
      obterTotalSelecionadoProduto(state.indexProdutoSelecionado);
    }

    async function reiniciarTela() {
      limparTela();
      telaBase.carregando = true;
      gradeBase.propriedadesConsulta = await servicoProduto.obterPropriedadesConsultaDefinicoes();
      await preenchePropriedadesNosFiltrosEOrdenacao();
      await defineValoresIniciaisGrade();
      if (UtilitarioGeral.validaLista(props.preSelecao) && props.preSelecao.length > 0) {
        await buscarProdutos();
        if (UtilitarioGeral.validaLista(computedProdutos.value)) {
          for (let index = 0; index < props.preSelecao.length; index += 1) {
            const indexP = computedProdutos.value.findIndex((prod) => prod.codigoDefinicao === props.preSelecao[index].codigoProdutoDefinicao);
            computedProdutos.value[indexP].codigoItem = props.preSelecao[index].codigoItem;
            computedProdutos.value[indexP].codigoItemNotaFiscal = props.preSelecao[index].codigoItemNotaFiscal;
            computedProdutos.value[indexP].quantidade = props.preSelecao[index].quantidade;
            if (props.preSelecao[index].fatorConversao !== 1) {
              computedProdutos.value[indexP].unidadeMovimento = props.preSelecao[index].siglaUnidadeMovimento;
              computedProdutos.value[indexP].quantidadeMovimento = props.preSelecao[index].quantidadeMovimento;
            } else {
              computedProdutos.value[indexP].unidadeMovimento = computedProdutos.value[indexP].unidade;
              computedProdutos.value[indexP].quantidadeMovimento = props.preSelecao[index].quantidade;
            }
            computedProdutos.value[indexP].casasDecimais = props.preSelecao[index].casasDecimais;
          }

          for (let index = 0; index < computedProdutos.value.length; index += 1) {
            await buscarEstoques(index);
            preencherQtdPreSelecionada(index);
            obterTotalSelecionadoProduto(index);
          }
        }
      }
      telaBase.carregando = false;
    }

    onBeforeMount(async () => {
      reiniciarTela();
    });

    watch(async () => computedEmpresa.value, async () => {
      reiniciarTela();
    });

    return {
      props,
      state,
      telaBase,
      gradeBase,
      ECustomRenderRow,
      ETipoSelecaoProduto,
      ETipoRastreabilidade,
      ETipoControleProducao,
      UtilitarioMascara,
      UtilitarioData,
      UtilitarioGeral,
      computedProdutos,
      computedCodigosSelecionados,
      computedEmpresa,
      computedControles,
      buscarProdutos,
      buscarEstoques,
      obterClasseLinha,
      selecaoAlterada,
      rowHandlers,
      preencherIdentificador,
      editarQuantidade,
      adicionarQuantidade,
    };
  },
});
